'use client';

import { LegalNavDock } from '@pieleaf/shared/nav-dock/legal-dock';
import { MainNavDock } from '@pieleaf/shared/nav-dock/main-dock';
import { usePathname } from 'next/navigation';

const LEGAL_PATH_SUFFIXES = ['/privacy-policy', '/terms-of-service', '/security', '/gdpr', '/cookie-policy', '/data-deletion'];

export const ContextualNavDock = () => {
  const pathname = usePathname() ?? '';
  const isLegal = LEGAL_PATH_SUFFIXES.some(suffix => pathname.endsWith(suffix) || pathname.includes(`${suffix}/`));
  return isLegal ? <LegalNavDock /> : <MainNavDock />;
};
